import { types } from './types';
import Set from "./Set/Set";
import Get from "./Get/Get";
import Delete from "./Delete/Delete";
import Exists from "./Exists/Exists";
import GetTTL from "./GetTTL/GetTTL";
import SetTTL from "./SetTTL/SetTTL";
import Append from "./Append/Append";
import Prepend from "./Prepend/Prepend";

/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @param       setOpenVariable - open variable function that allows us to open
 * @param       showAlert -  show alert
 * @returns     JSX.Element
 * @author      Onur DOGUCU
 */
function Actions(action, showAlert, variables, setOpenVariable, automId) {
    switch (action.actionName) {
        case types.GET:
            return <Get action={action} showAlert={showAlert} variables={variables}
                                setOpenVariable={setOpenVariable} automId={automId} />;
        case types.SET:
            return <Set action={action} showAlert={showAlert} variables={variables}
                            setOpenVariable={setOpenVariable} />;
        case types.DELETE:
            return <Delete action={action} showAlert={showAlert} variables={variables}
                        setOpenVariable={setOpenVariable} />;
        case types.EXISTS:
            return <Exists action={action} showAlert={showAlert} variables={variables}
                           setOpenVariable={setOpenVariable} />;
        case types.GETTTL:
            return <GetTTL action={action} showAlert={showAlert} variables={variables}
                           setOpenVariable={setOpenVariable} />;
        case types.SETTTL:
            return <SetTTL action={action} showAlert={showAlert} variables={variables}
                           setOpenVariable={setOpenVariable} />;
        case types.PREPEND:
            return <Prepend action={action} showAlert={showAlert} variables={variables}
                           setOpenVariable={setOpenVariable} />;
        case types.APPEND:
            return <Append action={action} showAlert={showAlert} variables={variables}
                           setOpenVariable={setOpenVariable} />;
        default:
            break;
    }
}

export default Actions;
